(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var adAppJS = /*#__PURE__*/function () {
  function adAppJS() {(0, _classCallCheck2["default"])(this, adAppJS);
    this.init();
  }(0, _createClass2["default"])(adAppJS, [{ key: "init", value: function init()
    {
      this.adApp(); // 顶部悬浮广告
    } }, { key: "adApp", value: function adApp()
    {

      /*=================移动端顶部悬浮广告位 Start=====================*/
      var oBtn = document.querySelector('.bible-easy .close-sticky');
      var oApp = document.querySelector('.bible-easy');
      var oDownloadBtn = document.querySelector('.bible-easy .app-download');

      // 1、关闭悬浮广告图，并添加状态
      var curtime = Math.round(new Date().getTime() / 1000); // 用户访问网站的起始时间
      if (oBtn) {
        oBtn.addEventListener('click', function () {
          var clickTime = Math.round(new Date().getTime() / 1000); // 记录用户关闭广告图的时间
          oApp.style.display = 'none';
          window.localStorage.setItem('closeApp', 'true');
          window.localStorage.setItem('closeTime', clickTime);
        });
      }

      // 2、当移动端的时候直接显示悬浮广告图
      if ($(window).width() <= 1200) {
        oApp.style.display = 'block';
      }

      // 3、先判断之前用户是否关闭广告图,并且在两天之内当用户访问网站的时候就不显示广告图
      var lastTime = window.localStorage.getItem('closeTime'); // 获取上次用户关闭广告图的时间
      var longTime = curtime - lastTime; // 计算时间差值
      if (window.localStorage.getItem('closeApp') == 'true' && longTime < 172800) {
        oApp.style.display = 'none';
      }

      // 4、APP下载按钮分别跳转到苹果和谷歌商店
      if (oDownloadBtn) {
        oDownloadBtn.addEventListener('click', function () {
          if (getMobileOperatingSystem() == 'Android') {
            window.open(window._custom_config.app_google_play_link, '_blank');
          } else if (getMobileOperatingSystem() == 'iOS') {
            window.open(window._custom_config.app_apple_store_link, '_blank');
          }
        });
      }

      // 5、检查用户的系统
      function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
          return "Android";
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
        }

        return "unknown";
      }

      /*=================移动端顶部悬浮广告位 End=====================*/

    } }]);return adAppJS;}();var _default =


adAppJS;exports["default"] = _default;

},{"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/createClass":5,"@babel/runtime/helpers/interopRequireDefault":6}],2:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports["default"] = void 0;var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var callBtnJS = /*#__PURE__*/function () {

  function callBtnJS() {(0, _classCallCheck2["default"])(this, callBtnJS);
    this.init();
  }(0, _createClass2["default"])(callBtnJS, [{ key: "init", value: function init()
    {
      document.querySelectorAll(".gospelCallBox").length > 0 && this.gospelCall(); // 号招性按钮
    } }, { key: "gospelCall", value: function gospelCall()

    {
      var callBtn = document.querySelectorAll(".gospelCallBox");
      callBtn.forEach(function (value, key) {
        value.addEventListener('click', function () {
          // 获取当前畅的链接和打开方式
          var href = $(value).attr('data-link');
          var target = $(value).attr('data-target');

          // 点击打开
          if (href.includes('tawk')) {
            window.open(href, target, 'location=yes,height=570,width=520,scrollbars=no,status=no');
          } else {
            window.open(href, target);
          }
        });
      });
    } }]);return callBtnJS;}();var _default =



callBtnJS;exports["default"] = _default;

},{"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/createClass":5,"@babel/runtime/helpers/interopRequireDefault":6}],3:[function(require,module,exports){
"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _adApp = _interopRequireDefault(require("./Modules/common/adApp"));
var _callBtn = _interopRequireDefault(require("./Modules/common/callBtn"));var

commonJS = /*#__PURE__*/function () {
  function commonJS() {(0, _classCallCheck2["default"])(this, commonJS);
    this.init();
  }(0, _createClass2["default"])(commonJS, [{ key: "init", value: function init()
    {
      new _adApp["default"]();
      new _callBtn["default"]();
    } }]);return commonJS;}();

new commonJS();

},{"./Modules/common/adApp":1,"./Modules/common/callBtn":2,"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/createClass":5,"@babel/runtime/helpers/interopRequireDefault":6}],4:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
},{}],5:[function(require,module,exports){
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
},{}],6:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}]},{},[3])

//# sourceMappingURL=common.js.map
